import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, Input, input, output } from '@angular/core';

type AdmonitionType = 'info' | 'error' | 'success' | 'warning';

@Component({
	selector: 'admonition-box',
	templateUrl: './admonition.component.html',
	styleUrls: ['./admonition.component.scss'],
	animations: [
		trigger('animation', [
			state('void', style({ opacity: 0, height: 0 })),
			state('*', style({ opacity: 1 })),
			transition(':enter', animate(`400ms ease-out`)),
			transition(':leave', animate(`400ms ease-in`)),
		]),
	],
	standalone: false,
})
export class AdmonitionComponent {
	public readonly type = input<AdmonitionType>('info');

	@Input() public header: string = '';
	public readonly content = input<string>('');
	public readonly closable = input<boolean>(false);
	public readonly noPadding = input<boolean>(false);

	// eslint-disable-next-line @angular-eslint/no-output-native
	public readonly close = output<void>();

	@HostBinding('@animation') get state(): string {
		return '';
	}

	public closeClick() {
		this.close.emit(undefined);
	}
}
